/**
 * Select all items in a fieldset when label is clicked
 */
import $ from "dabbyjs/src/core/dabby/dabby.js";
import "dabbyjs/src/core/each/each.js";
import "dabbyjs/src/attributes/attr/attr.js";
import "dabbyjs/src/traversal/parents/parents.js";
import "dabbyjs/src/events/on/on.js";
import "dabbyjs/src/attributes/prop/prop.js";
import "dabbyjs/src/traversal/filter/filter.js";

export default obj => {
	obj.each((i, item) => {
		const $this = $(item),
			id = $this.attr("id");
		$("label[for="+id+"]", $this.parent()).on("click", () => {
			$("input[type=checkbox]", $this).each((i, item) => {
				const box = $(item);
				box.prop("checked", !box.is(":checked"));
			});
		});
	});
};
